import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_OVER_CAPACITY_SESSIONS = requestConstantsMaker('GET_OVER_CAPACITY_SESSIONS');
export const GET_COURSE_SESSIONS_FOR_COURSE_SCHEDULE = requestConstantsMaker('GET_COURSE_SESSIONS_FOR_COURSE_SCHEDULE');
export const GET_COURSE_SESSIONS_FOR_RESCHEDULE = requestConstantsMaker('GET_COURSE_SESSIONS_FOR_RESCHEDULE');
export const UPDATE_COURSE_SESSION = requestConstantsMaker('UPDATE_COURSE_SESSION');
/**** 20200217 ****/

export const GET_ALL_COURSE_SESSION_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_COURSE_SESSION_BY_SPECIFICATION');